import { Form, Input, Typography } from "antd";
import React from "react";

const NutritionistInvestigations = () => {
  return (
    <>
      <Typography>Blood Investigations</Typography>
      <div className="subsection-card">
        <Form.Item
          label="Hemoglobin(Hb) (g/dl)"
          name={["blood_investigations", "hemoglobin"]}
        >
          <Input.TextArea autoSize={{ maxRows: 2 }} style={{ maxWidth: 600 }} />
        </Form.Item>
        <Form.Item
          label="Random Blood Sugar(RBS) (mg/dl)"
          name={["blood_investigations", "rbs"]}
        >
          <Input.TextArea autoSize={{ maxRows: 2 }} style={{ maxWidth: 600 }} />
        </Form.Item>
        <Form.Item
          label="Albumin (g/dl)"
          name={["blood_investigations", "albumin"]}
        >
          <Input.TextArea autoSize={{ maxRows: 2 }} style={{ maxWidth: 600 }} />
        </Form.Item>
        <Form.Item
          label="Total Proteins (mg/dl)"
          name={["blood_investigations", "total_proteins"]}
        >
          <Input.TextArea autoSize={{ maxRows: 2 }} style={{ maxWidth: 600 }} />
        </Form.Item>
        <Form.Item label="Urea (mg/dl)" name={["blood_investigations", "urea"]}>
          <Input.TextArea autoSize={{ maxRows: 2 }} style={{ maxWidth: 600 }} />
        </Form.Item>
        <Form.Item
          label="sr. Creatinine (mg/dl)"
          name={["blood_investigations", "creatinine"]}
        >
          <Input.TextArea autoSize={{ maxRows: 2 }} style={{ maxWidth: 600 }} />
        </Form.Item>
        <Form.Item
          label="Na + (meq/dl)"
          name={["blood_investigations", "sodium"]}
        >
          <Input.TextArea autoSize={{ maxRows: 2 }} style={{ maxWidth: 600 }} />
        </Form.Item>
        <Form.Item
          label="K+ (meq/dl)"
          name={["blood_investigations", "potassium"]}
        >
          <Input.TextArea autoSize={{ maxRows: 2 }} style={{ maxWidth: 600 }} />
        </Form.Item>
        <Form.Item
          label="Cl- (meq/dl)"
          name={["blood_investigations", "chlorine"]}
        >
          <Input.TextArea autoSize={{ maxRows: 2 }} style={{ maxWidth: 600 }} />
        </Form.Item>
      </div>
    </>
  );
};

export default NutritionistInvestigations;
